import moment from "moment";

export const handleDateChange = (newDate, oldDate, setDate, format) => {
    let date = null;

    if (format === null) format = "dd/MMM/yyyy";
    if (newDate === null) return;
    if (!moment.isMoment(newDate)) {
        const el = newDate.currentTarget
            ? newDate.currentTarget.defaultValue
            : newDate;
        const elementValue = moment(el).toDate();
        date = elementValue;
    } else {
        date = newDate;
    }
    if (moment(oldDate).format(format) !== moment(date).format(format)) {
        setDate(date);
    }
};
